var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1186",
    "data-name": "Grupo 1186",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.111,
    height: 22.98,
    viewBox: "0 0 24.111 22.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1717",
    "data-name": "Trazado 1717",
    d: "M38.634,30.9a6.452,6.452,0,1,0-6.434-6.47A6.435,6.435,0,0,0,38.634,30.9Zm0-11.207A4.737,4.737,0,1,1,33.9,24.47,4.738,4.738,0,0,1,38.634,19.7Z",
    transform: "translate(-26.614 -18)",
    fill: "#e73758"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1718",
    "data-name": "Trazado 1718",
    d: "M17.248,66.645H39.663a.86.86,0,0,0,.848-.848,8.118,8.118,0,0,0-8.1-8.1H24.5a8.118,8.118,0,0,0-8.1,8.1A.86.86,0,0,0,17.248,66.645ZM24.5,59.4h7.919a6.376,6.376,0,0,1,6.328,5.551H18.168A6.376,6.376,0,0,1,24.5,59.4Z",
    transform: "translate(-16.4 -43.665)",
    fill: "#e73758"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0150b0b8bd8f2cca383c264bd063d693.svg";
export { ForwardRef as ReactComponent };